<template>
  <span v-if="date">{{ formatted }}</span>
  <span v-else class="grey--text">—</span>
</template>

<script>
export default {
  props: { item: { type: Object, required: true } },
  computed: {
    date() {
      return this.item?.__dueDate ?? this.item?.dueDate ?? null;
    },
    formatted() {
      const d = this.date instanceof Date ? this.date : new Date(this.date);
      return d.toLocaleDateString(undefined, {
        year: "numeric",
        month: "short",
        day: "2-digit",
      });
    },
  },
};
</script>
